import { db } from "../db";
import { AttendanceSup } from "../../../domain/attendance-sup/Attendance";

export class AttendanceSupStoreDao {
  static async putEntry(...entry: AttendanceSup[]) {
    return db.entriesSup.bulkPut(entry);
  }

  static async putDeparture(...departure: AttendanceSup[]) {
    return db.departuresSup.bulkPut(departure);
  }

  static async delete(unityId: number, start: number, end: number) {
    await db.entriesSup
      .where(["unityId", "timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .delete();
    await db.departuresSup
      .where(["unityId", "timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .delete();
  }

  static async getAllUnityEntries(unityId: number, start: number, end: number) {
    return db.entriesSup
      .where(["unityId+timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .reverse()
      .sortBy("timestamp");
  }

  static async getAllEntries(start: number, end: number) {
    return db.entriesSup
      .where("timestamp")
      .between(start, end, true, true)
      .reverse()
      .sortBy("timestamp");
  }

  static async getLastEntryAboveTimestamp(preferredTimestamp: number) {
    return db.entriesSup
      .where("timestamp")
      .aboveOrEqual(preferredTimestamp)
      .last();
  }

  static async getLastDepartureAboveTimestamp(preferredTimestamp: number) {
    return db.departuresSup
      .where("timestamp")
      .aboveOrEqual(preferredTimestamp)
      .last();
  }

  static async getAllUnityDepartures(
    unityId: number,
    start: number,
    end: number
  ) {
    return db.departuresSup
      .where(["unityId", "timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .reverse()
      .sortBy("timestamp");
  }

  static async getAllDepartures(start: number, end: number) {
    return db.departuresSup
      .where("timestamp")
      .between(start, end, true, true)
      .reverse()
      .sortBy("timestamp");
  }

  static async deleteEntries(start: number, end: number) {
    return db.entriesSup
      .where(["timestamp"])
      .between([start], [end], true, true)
      .delete();
  }

  static async deleteUnityEntries(unityId: number, start: number, end: number) {
    return db.entriesSup
      .where(["unityId+timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .delete();
  }

  static async deleteUnityDepartures(
    unityId: number,
    start: number,
    end: number
  ) {
    return db.departuresSup
      .where(["unityId", "timestamp"])
      .between([unityId, start], [unityId, end], true, true)
      .delete();
  }

  static async deleteDepartures(start: number, end: number) {
    return db.departuresSup
      .where(["timestamp"])
      .between([start], [end], true, true)
      .delete();
  }

  static async getEntry(ownerUid: string, start: number, end: number) {
    return db.entriesSup
      .where(["ownerUid", "timestamp"])
      .between([ownerUid, start], [ownerUid, end])
      .first();
  }

  static async getEntryByReference(reference: string) {
    return db.entriesSup.get(reference);
  }

  static async getDeparture(ownerUid: string, start: number, end: number) {
    return db.departuresSup
      .where(["ownerUid", "timestamp"])
      .between([ownerUid, start], [ownerUid, end])
      .first();
  }

  static async getDepartureByReference(reference: string) {
    return db.departuresSup.get(reference);
  }
}
